'use client';

import React, {useEffect} from 'react';
import {usePathname, useSearchParams} from 'next/navigation';
import Script from "next/script";
import {yandex} from "../../../libs/constants/metrika";

const YandexMetrika = () => {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        const url = `${pathname}?${searchParams}`;
        ym(52577989, 'hit', url);
    }, [pathname, searchParams]);

    return <Script id="metrika-counter" strategy="afterInteractive">
        {yandex}
    </Script>;
};

export default YandexMetrika;
